import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { getSS, setSS, loadIndexPage, getUrlParameter } from '../../helpers'
import { getMembership, saveMembership } from '../../api'

const CardReaderConfirm: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  const [ processing, setProcessing ] = useState(true)

  let membership = getSS('membership')

  useEffect(() => {
    async function getCurrentMembership() {
      let resp = await getMembership(params.id)
      console.log(membership.public_id, resp.data.public_id);

      membership.address_1 = resp.data.address_1;
      membership.address_2 = resp.data.address_2;
      membership.address_3 = resp.data.address_3;
      membership.amount = resp.data.amount;
      membership.country = resp.data.country;
      membership.county_state = resp.data.county_state;
      membership.date_created = resp.data.date_created;
      membership.date_last_updated = resp.data.date_last_updated;
      membership.email = resp.data.email;
      membership.first_name = resp.data.first_name;
      membership.ga_document_host = resp.data.ga_document_host;
      membership.ga_tracking_id = resp.data.ga_tracking_id;
      membership.gtm_container_id = resp.data.gtm_container_id;
      membership.id = resp.data.id;
      membership.initial_location = resp.data.initial_location;
      membership.last_name = resp.data.last_name;
      membership.membership_form = resp.data.membership_form;
      membership.membership_form_id = resp.data.membership_form_id;
      membership.membership_form_name = resp.data.membership_form_name;
      membership.optins_email = resp.data.optins_email;
      membership.optins_phone = resp.data.optins_phone;
      membership.optins_post = resp.data.optins_post;
      membership.organisation = resp.data.organisation;
      membership.payment_type = resp.data.payment_type;
      membership.phone = resp.data.phone;
      membership.postcode = resp.data.postcode;
      membership.public_id = resp.data.public_id;
      membership.salutation = resp.data.salutation;
      membership.selected_membership = resp.data.selected_membership;
      membership.session_id = resp.data.session_id;
      membership.town_city = resp.data.town_city;

      if (resp.data.selected_membership.value === 'jointfriend' || resp.data.selected_membership.value === 'jointfamfriend' || resp.data.selected_membership.value === 'wakehurst_jointfriend' || resp.data.selected_membership.value === 'wakehurst_jointfamfriend' || resp.data.selected_membership.value === 'jointfriendplus' || resp.data.selected_membership.value === 'jointfamfriendplus') {
        membership.second_named_adult_email = resp.data.second_named_adult_email;
        membership.second_named_adult_first_name = resp.data.second_named_adult_first_name;
        membership.second_named_adult_last_name = resp.data.second_named_adult_last_name;
        membership.second_named_adult_salutation = resp.data.second_named_adult_salutation;
        membership.second_named_adult_phone = resp.data.second_named_adult_phone;
        membership.optins_second_adult_email = resp.data.optins_second_adult_email;
        membership.optins_second_adult_phone = resp.data.optins_second_adult_phone;
        membership.optins_second_adult_post = resp.data.optins_second_adult_post;
      }

      membership.process_payment = true
      membership.payment_method = 'CardReader'
      membership.card_reader_payment = resp.data.card_reader_payment

      setSS('membership', membership)

      if (!membership.card_reader_payment) {
        membership.card_reader_payment = getUrlParameter('InvoiceId')
        const savedMembership: any = await saveMembership(membership)
        console.log(savedMembership);
        setProcessing(false)
        if (savedMembership?.status === 200) {
          setProcessing(false);
        } else {
          alert('something went wrong creating the membership!')
        }
      }
    }
    getCurrentMembership()
  })

  return (
    <form className="card-reader-details" name="membershipForm">
      <div className="row intro">
        <div className="large-12 columns box">
          <div className="intro-copy">
            <h1>Thank you!</h1>
          </div>
        </div>
      </div>
      <div className="row payment-details">
        <div className="medium-6 columns box">
          <div className="member-details">
            <div className="title">Membership type</div>
            <div className="details">
              <p>{membership.selected_membership.title}</p>
            </div>
            <div className="title">Payee</div>
            <div className="details">
              <p>{membership.salutation} {membership.first_name} {membership.last_name}</p>
            </div>
            <div className="title">Membership fee</div>
            <div className="details">
              <p>£{(membership.amount).toFixed(2)}</p>
            </div>
            <div className="title">Payment reference</div>
            <div className="details">
              <p>{membership.id}</p>
            </div>
          </div>
          <div className="member-details">
            <div className="title">Status</div>
            { processing &&
              <div className="details">
                <img src="/assets/default/images/ajax-loader.gif" alt="loading" className="loader"/>
                <p>Processing - please wait</p>
              </div>
            }
            { !processing &&
              <div className="details">
                <p>Transaction complete</p>
              </div>
            }
          </div>
        </div>
        <div className="medium-6 columns box">
          <img src={membership.selected_membership.image} alt={membership.selected_membership.alt} />
          <button className="btn-cta" onClick={() => loadIndexPage(navigate, url)}>Reset form</button>
        </div>
      </div>
    </form>
  )
}

export default CardReaderConfirm